import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentDialogAgentSuggestionFooterOpenCommentWireframe from './VeltCommentDialogAgentSuggestionFooterOpenCommentWireframe/VeltCommentDialogAgentSuggestionFooterOpenCommentWireframe';
var VeltCommentDialogAgentSuggestionFooterWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-agent-suggestion-footer-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogAgentSuggestionFooterWireframe.OpenComment = VeltCommentDialogAgentSuggestionFooterOpenCommentWireframe;
export default VeltCommentDialogAgentSuggestionFooterWireframe;
